function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgChainikMainIcon = function SvgChainikMainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 101 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3852_72693)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2393,
    cy: 33.122,
    rx: 5.70215,
    ry: 5.7038,
    fill: "url(#paint0_linear_3852_72693)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2038 37.8544C26.8162 37.8544 28.934 35.736 28.934 33.1228C28.934 30.5096 26.8162 28.3912 24.2038 28.3912C21.5914 28.3912 19.4736 30.5096 19.4736 33.1228C19.4736 35.736 21.5914 37.8544 24.2038 37.8544ZM24.15 37.4014C26.4761 37.4014 28.3618 35.5152 28.3618 33.1884C28.3618 30.8616 26.4761 28.9753 24.15 28.9753C21.8239 28.9753 19.9382 30.8616 19.9382 33.1884C19.9382 35.5152 21.8239 37.4014 24.15 37.4014Z",
    fill: "url(#paint1_linear_3852_72693)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.1562,
    cy: 33.1898,
    rx: 4.21181,
    ry: 4.21304,
    fill: "url(#paint2_linear_3852_72693)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3852_72693)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9082 18.1784C21.9596 18.0898 22.3272 18.0174 22.3938 18.0524C22.5204 18.1621 22.6002 18.2928 22.6781 18.4204C22.7642 18.5614 22.8479 18.6986 22.9899 18.799C23.0585 18.6715 23.2546 18.3814 23.4279 18.2927C23.4291 18.2921 23.428 18.2861 23.4262 18.276C23.4164 18.2201 23.3846 18.0389 23.5879 17.9638C23.7364 17.6955 24.0506 17.6955 24.0506 17.6955C24.0506 17.6955 23.9211 17.3409 24.0887 17.2942H24.4296C24.4614 17.3074 24.5248 17.3581 24.5248 17.4552C24.5248 17.4874 24.5078 17.5522 24.4933 17.6071C24.4827 17.6475 24.4734 17.6826 24.4734 17.6955C24.582 17.7134 24.8273 17.7809 24.9324 17.9638C25.0022 17.9731 25.1335 18.0496 25.1 18.2811L25.2942 18.4561C26.473 17.1519 27.3833 19.5969 25.3647 20.5208C25.2936 20.5838 25.1099 20.721 24.9743 20.7751C24.9762 20.8226 24.9625 20.9193 24.8619 20.9454H23.666C23.6298 20.9454 23.5669 20.9104 23.5536 20.7751C23.4565 20.7246 23.2584 20.6142 23.2432 20.5768C22.9753 20.4532 22.4117 19.9245 22.3005 18.799C22.2524 18.5725 22.1697 18.4832 22.0699 18.3754C22.0196 18.321 21.965 18.262 21.9082 18.1784ZM25.6376 19.9765C25.7024 19.7136 25.7614 19.0885 25.4796 18.6909C25.5469 18.5953 25.7352 18.4058 25.95 18.4133C26.2185 18.4226 26.3366 18.8566 26.2509 19.2205C26.1975 19.4188 25.9439 19.8159 25.6376 19.9765Z",
    fill: "#F4B100"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.864 33.1634L20.4772 33.0705L20.5982 33.3962L20.4011 33.4603C20.4978 33.6492 20.5646 34.05 21.3305 34.1658C21.5027 34.2399 21.5818 36.0256 22.3212 36.4882L22.5544 36.1691C21.6648 35.4829 21.792 34.5032 21.6187 33.9134C21.4454 33.3235 21.1491 33.1308 20.9024 33.0213L20.864 33.1634Z",
    fill: "#F4B100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9124 33.1594L28.2992 33.0665L28.1782 33.3922L28.3753 33.4563C28.2785 33.6453 28.2117 34.046 27.4458 34.1618C27.2737 34.2359 27.1945 36.0216 26.4552 36.4843L26.222 36.1651C27.1116 35.479 26.9843 34.4993 27.1576 33.9094C27.3309 33.3195 27.6273 33.1269 27.874 33.0173L27.9124 33.1594Z",
    fill: "#F4B100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3504 9.64852C25.5925 10.6244 24.9976 11.6118 24.0217 11.8539C23.0458 12.096 22.0584 11.5011 21.8163 10.5252C21.5742 9.54931 22.1691 8.56192 23.145 8.31983C24.1209 8.07773 25.1083 8.67261 25.3504 9.64852Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7748 15.2141L21.7879 17.9908C19.3208 14.9946 20.7706 11.9764 23.3308 9.59637C25.9976 7.1172 29.0236 6.09394 31.7011 8.97415L38.7419 16.548L35.7551 19.3247L33.7717 17.1912L33.6651 17.2904C33.6651 17.2904 35.2632 20.3785 32.4256 23.0164C30.3988 24.9005 28.0327 25.3501 26.1287 23.302C24.2049 21.2325 25.039 18.7071 26.4375 16.5321C26.6735 16.1672 26.9148 15.814 27.1477 15.4728C28.3164 13.7618 29.2767 12.3558 28.3176 11.3241C27.5044 10.4494 26.3884 10.5323 25.2149 11.6232C23.9349 12.8132 23.7068 13.9797 24.7748 15.2141ZM29.133 16.6774C29.7684 15.7027 30.4878 14.5989 30.5587 13.7349C32.0859 15.3777 33.7342 18.2204 31.7074 20.1046C30.7473 20.9971 29.6541 21.019 28.8608 20.1656C27.9484 19.1842 28.303 17.9399 29.0449 16.8127C29.074 16.7679 29.1034 16.7228 29.133 16.6774Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2876 21.3165C24.7656 21.1458 25.1124 19.728 25.2005 19.7187L26.7463 23.8742C23.0954 22.0869 22.3064 23.4383 21.5201 24.5911C21.4817 24.6475 21.3957 24.6242 21.3919 24.5561C21.3265 23.4012 21.4234 21.4084 22.2876 21.3165Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9219 7.6726C31.8359 2.5275 38.2332 6.36372 35.5166 13.4807L29.9219 7.6726ZM34.8606 12.3721C36.6411 8.64828 32.4006 3.33148 30.8832 8.10084L34.8606 12.3721Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6799 37.54V22.3926H9.60175V28.8011H6.68879H6.68879C4.94101 28.8011 4.35842 28.8011 4.35842 26.9077V22.3926H0.280273V27.3446C0.280273 30.6945 1.44546 31.7141 5.66925 31.7141H9.60175V37.54H13.6799Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9267 37.54H44.9942V35.064H44.8486C44.8486 35.064 43.5333 37.54 40.1834 37.54C35.9596 37.54 34.7988 35.2096 34.7988 31.7141V22.3926H38.877V30.8402C38.877 33.4618 39.6052 34.627 41.4986 34.627C43.6834 34.627 44.8486 33.3162 44.8486 30.2576V22.3926H48.9267V29.9663V37.54Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3163 19.6686C43.3163 20.473 42.6642 21.1251 41.8598 21.1251C41.0554 21.1251 40.4033 20.473 40.4033 19.6686C40.4033 18.8642 41.0554 18.2122 41.8598 18.2122C42.6642 18.2122 43.3163 18.8642 43.3163 19.6686Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1295 31.5684V37.54H66.2077V22.3926H62.1295V28.3642H56.4492V22.3926H52.3711V37.54H56.4492V31.5684H62.1295Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2548 37.54V22.3926H79.1767V30.2576C79.1767 33.3162 78.0115 34.627 75.8268 34.627C73.9333 34.627 73.2051 33.4618 73.2051 30.8402V22.3926H69.127V31.7141C69.127 35.2096 70.2921 37.9769 74.5159 37.9769C77.8658 37.9769 79.1767 35.064 79.1767 35.064H79.3223V37.54H83.2548Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1543 22.3926V37.54H90.2324V32.9375L91.8928 31.2189L95.7379 37.54H100.719L94.7184 28.3059L100.428 22.3926H95.6214L90.2324 28.5098V22.3926H86.1543Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3852_72693",
    x: 18.533,
    y: 27.414,
    width: 11.4126,
    height: 11.4159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.00206433,
    result: "effect1_foregroundBlur_3852_72693"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3852_72693",
    x: 21.9082,
    y: 17.2942,
    width: 4.68297,
    height: 3.68676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0355124,
    dy: 0.0355124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819444 0 0 0 0 0.538914 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3852_72693"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3852_72693",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3852_72693",
    x1: 19.5415,
    y1: 29.8163,
    x2: 28.3236,
    y2: 37.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350949,
    stopColor: "#FED032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886291,
    stopColor: "#EC8F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3852_72693",
    x1: 20.7372,
    y1: 29.9468,
    x2: 26.9275,
    y2: 37.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48984,
    stopColor: "#F9CC21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE47A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3852_72693",
    x1: 21.1107,
    y1: 30.4352,
    x2: 25.8098,
    y2: 35.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC923"
  }))));
};
export default SvgChainikMainIcon;